import { useQuery } from 'react-query';
import { axiosInstance } from '../services/apiClient';
import { DiagnosisConsumptionReadDTO } from '../generated/api-client';

/**
 * Restituisce tutti i consumi della diagnosi (una sola chiamata API).
 * Equivalente concettuale a useDiagnosisEnergyVectorsByDiagnosisId per i consumi.
 */
export const useDiagnosisConsumptionsByDiagnosisId = (diagnosisId: string) => {
  return useQuery<DiagnosisConsumptionReadDTO[]>(
    `diagnosis-consumptions-${diagnosisId}`,
    () =>
      axiosInstance
        .get<DiagnosisConsumptionReadDTO[]>(`/diagnosis-consumption/by-diagnosis/${diagnosisId}`)
        .then(res => res.data),
    {
      enabled: !!diagnosisId,
    }
  );
};
